export default __webpack_public_path__ + "static/media/bg-green.a0cf93e1.png";